module.exports = __webpack_public_path__ + "img/s.0b33fde3.jpg";